/* import __COLOCATED_TEMPLATE__ from './reporting-synthetic-data.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const ReportingSyntheticData = templateOnlyComponent<Signature>();
export default ReportingSyntheticData;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::UserMenu::ReportingSyntheticData': typeof ReportingSyntheticData;
    'inbox2/user-menu/reporting-synthetic-data': typeof ReportingSyntheticData;
  }
}
